<neptune-header
  header-action-items
  [attr.user-initials]="userInitials"
  #neptuneHeader
>
  <span slot="application-name">Enterprise Data Editor</span>
</neptune-header>
